import { inject, Injectable } from '@angular/core';
import { NotificationService } from '../notification-service/notification-service';
import { ErrorReportingService } from '../error-reporting-service/error-reporting-service';
import { SUPPORT_HINT } from '../../support-contact';

/**
 * Centralised handling for entities dropped during reference resolution (see the data services'
 * `#resolved*` computeds). Logs the specific ids for developers (Sentry) and shows the user a
 * single generic, actionable message — inconsistency is a backend data problem the user can't fix.
 */
@Injectable({
  providedIn: 'root',
})
export class DataConsistencyReporter {
  private readonly errorReporting = inject(ErrorReportingService);
  private readonly notificationService = inject(NotificationService);

  reportDropped(dropped: string[], context: string): void {
    if (dropped.length === 0) {
      return;
    }

    this.errorReporting.report(
      new Error(`Dropped inconsistent data: ${dropped.join('; ')}`),
      context,
    );
    this.notificationService.showTemporaryError(
      `Některá data se nepodařilo zobrazit. Zkuste akci zopakovat. ${SUPPORT_HINT}`,
      'Zavřít',
    );
  }
}
